import type { ApiClient } from '../client';
import { MEDIA_PATHS } from '../../../config/api-paths';
import type { ApiResponse, PresignGetResponse, UploadImageResponse } from '../types';
import type { MediaOwnerType } from '../../../utils/tenantMediaUpload';

export function bindMedia(client: ApiClient) {
  return {
    async uploadImage(
      file: File,
      options: {
        ownerType: MediaOwnerType;
        ownerId: string;
        fieldName?: string;
        academicYear?: string;
        storageSlot?: string;
        /** Super-admin: scope upload to a tenant (`x-tenant-id`). */
        tenantId?: string | number;
      }
    ): Promise<ApiResponse<UploadImageResponse>> {
      const form = new FormData();
      form.append(options.fieldName ?? 'file', file);
      form.append('owner_type', options.ownerType);
      form.append('owner_id', options.ownerId);
      if (options.academicYear?.trim()) {
        form.append('academic_year', options.academicYear.trim());
      }
      if (options.storageSlot?.trim()) {
        form.append('storage_slot', options.storageSlot.trim());
      }
      return client.uploadForm<UploadImageResponse>(MEDIA_PATHS.upload, form, options.tenantId);
    },

    async uploadDocument(
      file: File,
      options: {
        ownerId: string;
        ownerType?: Extract<MediaOwnerType, 'student_document' | 'expense'>;
        fieldName?: string;
      }
    ): Promise<ApiResponse<UploadImageResponse>> {
      const form = new FormData();
      form.append(options.fieldName ?? 'file', file);
      form.append('owner_type', options.ownerType ?? 'student_document');
      form.append('owner_id', options.ownerId);
      return client.uploadForm<UploadImageResponse>(MEDIA_PATHS.uploadDocument, form);
    },

    async getMediaUrl(
      mediaId: string,
      /** Super-admin: scope lookup to a tenant (`x-tenant-id`). */
      tenantId?: string | number
    ): Promise<ApiResponse<PresignGetResponse>> {
      return client.request<PresignGetResponse>(MEDIA_PATHS.url(mediaId), { tenantId });
    },
  };
}
